import { FlagIcon, LandmarkIcon, MapPinIcon, ScrollText } from 'lucide-react'
import { BookMarked as LawIcon } from 'lucide-react'
import { pathMappingsAT, pathMappingsDE } from './paths'

export const documentTypeMappings = {
  clause: 'Gesetze',
  decision: 'Entscheidungen',
  rechtssatz: 'Rechtssätze',
  law: 'Gesetze',
}
export const documentTypeMappingsSingular = {
  clause: 'Gesetz',
  decision: 'Entscheidung',
  rechtssatz: 'Rechtssatz',
  law: 'Gesetz',
}

export const documentTypeFilters = {
  decision: {
    sortOptions: ['decisionDate', 'publishedDate', 'views'],
    facets: ['institution', 'decisionDate'],
  },
  rechtssatz: {
    sortOptions: ['decisionDate', 'publishedDate', 'views'],
    facets: ['institution', 'decisionDate'],
  },
  clause: {
    sortOptions: ['inEffectDate', 'outOfEffectDate', 'views'],
    facets: ['state', 'lawType', 'inEffectDate', 'outOfEffectDate'],
  },
  law: {
    sortOptions: ['inEffectDate', 'outOfEffectDate', 'views'],
    facets: ['state', 'lawType', 'inEffectDate', 'outOfEffectDate'],
  },
} satisfies Record<
  string,
  { sortOptions: Array<keyof typeof sortOptionMappings>; facets: string[] }
>

export const sortOptionMappings = {
  inEffectDate: {
    name: 'Inkrafttretungsdatum',
    description: 'Wann das Gesetz in Kraft getreten ist.',
  },
  outOfEffectDate: {
    name: 'Außerkrafttretungsdatum',
    description: 'Wann das Gesetz außer Kraft getreten ist.',
  },
  decisionDate: {
    name: 'Entscheidungsdatum',
    description:
      'Wann die Entscheidung von dem Gericht/der Behörde gefällt wurde.',
  },
  publishedDate: {
    name: 'Veröffentlichungsdatum',
    description:
      'Wann die Entscheidung von der publizierenden Stelle veröffentlicht wurde (z.B. im RIS oder Findok)',
  },
  changedDate: {
    name: 'Änderungsdatum',
    description: 'Wann die Entscheidung das letzte Mal aktualisiert wurde.',
  },
  views: {
    name: 'Popularität',
    description: 'Wie oft die Entscheidung aufgerufen wurde.',
  },
  count: {
    name: 'Popularität',
    description: 'Wie oft die Query aufgerufen wurde.',
  },
  _text_match: {
    name: 'Relevanz',
    description: 'Wie relevant die Entscheidung zu Ihrer Suchanfrage ist.',
  },
} as const

export const facetMappings = {
  institution: {
    name: 'Institutionen',
    icon: LandmarkIcon,
  },
  state: {
    name: 'Bundesland',
    icon: MapPinIcon,
  },
  // decisionType: 'Entscheidungstyp',
  lawType: {
    name: 'Gesetzestyp',
    icon: LawIcon,
  },
  jurisdiction: {
    name: 'Jurisdiktion',
    icon: FlagIcon,
  },
  legalCategories: {
    name: 'Rechtsgebiete',
    icon: ScrollText,
  },
} as const

export const lawTypeMappings: Record<string, string> = Object.fromEntries(
  [pathMappingsAT, pathMappingsDE].flatMap((mapping) =>
    Object.values(mapping).flatMap((section) => {
      if (!section.documentType.includes('law')) return []
      return Object.values(section.paths)
        .filter((path) => path.name && !path.type.endsWith('gazette'))
        .map((path) => [path.type.toLowerCase(), path.name])
    }),
  ),
)
